type Person = { first_name?: string | null; last_name?: string | null };

/**
 * The app's only person-name formatter: "First Last", skipping blank parts.
 * Returns `fallback` (default "") when the person or both names are missing,
 * so pass EMPTY_VALUE or "Unknown user" where the name is displayed.
 */
export const formatPersonName = (person?: Person | null, fallback = "") =>
  [person?.first_name, person?.last_name]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ") || fallback;
